module.exports = __webpack_public_path__ + "static/media/main_mob@2x.3d3b68cb.png";